import React from 'react';
import { useTranslation } from 'react-i18next';
import { FilterSelect } from '@klp/design/FilterPanel/FilterPanel';
import { translateProsjektSkjemaType } from '../utils';
import { useGetProsjektSkjemaTypesQuery } from '../services/rtkApi';

interface ProsjektskjematypeSelectorProps {
    selectedTypes: Array<string>;
    onChange: (types: Array<string>) => void;
    disabled?: boolean;
}

const ALL_OPTION = 'all';

export default function ProsjektskjematypeSelector({
    selectedTypes,
    onChange,
    disabled,
}: ProsjektskjematypeSelectorProps) {
    const { t } = useTranslation();
    const { data: prosjektSkjemaTypes, isLoading } =
        useGetProsjektSkjemaTypesQuery();

    const skjemaTypeNames = prosjektSkjemaTypes
        ? Object.keys(prosjektSkjemaTypes)
        : [];

    const currentValue =
        selectedTypes.length === 1 ? selectedTypes[0] : ALL_OPTION;

    return (
        <FilterSelect
            id="prosjektskjematype-selector"
            label={t('prosjekt.filter.prosjektskjematype.label')}
            value={currentValue}
            disabled={disabled || isLoading}
            options={[
                {
                    value: ALL_OPTION,
                    label: t('prosjekt.filter.prosjektskjematype.all'),
                },
                ...skjemaTypeNames.map((typeName) => ({
                    value: typeName,
                    label: translateProsjektSkjemaType(typeName),
                })),
            ]}
            onChange={(value) => onChange(value === ALL_OPTION ? [] : [value])}
        />
    );
}
